module.exports = __webpack_public_path__ + "img/home-delivery_medium@2x.1eb83256.jpg";